import {
  FulfillmentDisplayStatus,
  LineItem,
  LineItemFulfillment,
  Order,
  ShopifyAdminOrder,
} from "gpc-shared-types";
import { format } from "date-fns";
import { Link } from "react-router-dom";
import Box from "./Box";
import InvertBox from "./InvertBox";
import OrderDetailAddress from "./OrderDetailAddress";
import ProductLine from "./ProductLine";
import PaymentStatus from "./PaymentStatus";
import FulfillmentStatus from "./FulfillmentStatus";
import TrackingStatus from "./TrackingStatus";

export type OrderDetailsProps = Order;

export const OrderDetails = (order: OrderDetailsProps) => {
  const hasAddress = order?.meta?.pickupAddress || order?.shippingAddress;

  const lineItemsHeading = (lineItems: LineItem[] = []) =>
    `${lineItems.length} item${lineItems.length > 1 ? "s" : ""}`;

  const sumLineItems = (lineItems: LineItem[]) =>
    lineItems.reduce((accum, val) => accum + val.currentQuantity, 0);

  const fulfillments = order?.fulfilledLineItems ?? [];
  const unfulfilled = order?.unfulfilledLineItems ?? [];

  return (
    <div className="gpc__order-details">
      <Box>
        <div className="gpc__box-header">
          <h2 className="gpc__page-title">
            <Link to="/orders" className="gpc__orders-backlink">
              My Orders
            </Link>
            {` > ${order?.name}`}
          </h2>
        </div>
        <div className="gpc__box__controls">
          {/* <Link
            to={`/orders/${order?.id}`}
            className="gpc__button gpc__button--is-active"
          >
            Download Invoice
          </Link> */}
          {/* <Link to={`/orders/${order?.id}/resend`} className="gpc__button">
            Resend Order Email
          </Link> */}
          {/* <Link
            to={`/orders/${order?.id}/return-cancel`}
            className="gpc-returns__button"
          > */}
          {/* <Link
            to={`/orders/${resourceId}/return-cancel`}
            className={cancelReturnButtonClassName}
          >
            Return or Cancel Item
          </Link> */}
        </div>

        <div className="gpc__order-detail-row">
          <div className="gpc__box-header gpc__order_details_header">
            <h3 className="gpc__page-sub-title">Order Details</h3>
            {order?.createdAt && (
              <span className="gpc__order-created-at">
                Ordered on {format(new Date(order?.createdAt), "dd MMMM yyyy")}
              </span>
            )}
          </div>
          {order?.poNumber && (
            <div className="gpc__box-header gpc__order_details_header">
              <div className="gpc__order-detail-col gpc__order_details_header-item">
                <h4>PO Number</h4>
                <div>{order.poNumber}</div>
              </div>
            </div>
          )}
          <div className="gpc__box-header gpc__order_details_header">
            <div className="gpc__order-detail-col gpc__order_details_header-item">
              <PaymentStatus status={order.displayFinancialStatus} />
            </div>
          </div>
        </div>
        {
          <>
            <InvertBox>
              <div className="gpc__order-detail-row">
                {hasAddress ? (
                  <OrderDetailAddress
                    title={
                      order?.meta?.pickupAddress
                        ? "Pickup Address"
                        : "Delivery Address"
                    }
                    address={
                      order?.meta?.pickupAddress ?? order?.shippingAddress
                    }
                  />
                ) : (
                  <div className="gpc__order-detail-col">
                    <div className="gpc__order-detail-header">Address</div>
                    <div className="gpc__order-detail-item">
                      No shipping address provided
                    </div>
                  </div>
                )}
                <div className="gpc__order-detail-col">
                  {order.transactions &&
                    order.transactions[0]?.accountNumber &&
                    order.transactions[0]?.paymentIcon && (
                      <>
                        <div className="gpc__order-detail-header">
                          Payment Method
                        </div>
                        <div className="gpc__order-detail-item">
                          <div>
                            <img
                              src={order.transactions[0]?.paymentIcon?.src}
                              alt={order.transactions[0]?.paymentIcon?.altText}
                            />
                          </div>
                          {order.transactions[0]?.accountNumber}
                        </div>
                      </>
                    )}
                </div>
                <div className="gpc__order-detail-col">
                  <div className="gpc__order-detail-header">Order Summary</div>
                  <div className="gpc__order-detail-item flex-item">
                    <div>Subtotal:</div>
                    <div>
                      {
                        order?.currentSubtotalPriceSet?.presentmentMoney
                          ?.currencyCode
                      }{" "}
                      {` `}
                      {order?.currentSubtotalPriceSet?.presentmentMoney?.amount}
                    </div>
                  </div>
                  <div className="gpc__order-detail-item flex-item">
                    <div>Standard delivery:</div>
                    <div>
                      {
                        order?.totalShippingPriceSet?.presentmentMoney
                          ?.currencyCode
                      }{" "}
                      {` `}
                      {order?.totalShippingPriceSet?.presentmentMoney?.amount}
                    </div>
                  </div>
                  <div className="gpc__order-detail-item flex-item">
                    <div>GST:</div>
                    <div>
                      {
                        order?.currentTotalTaxSet?.presentmentMoney
                          ?.currencyCode
                      }{" "}
                      {` `}
                      {order?.currentTotalTaxSet?.presentmentMoney?.amount}
                    </div>
                  </div>
                  <div className="gpc__order-detail-item flex-item total-item">
                    <div className="gpc__order-detail-header">Total:</div>
                    <div>
                      {
                        order?.currentTotalPriceSet?.presentmentMoney
                          ?.currencyCode
                      }{" "}
                      {` `}
                      {order?.currentTotalPriceSet?.presentmentMoney?.amount}
                    </div>
                  </div>
                </div>
              </div>
            </InvertBox>

            {unfulfilled.length > 0 ? (
              <InvertBox>
                <div className="gpc__order-detail-row">
                  <div className="gpc__order-detail-col">
                    <FulfillmentStatus
                      status={"Pending"}
                      count={sumLineItems(unfulfilled)}
                    />
                  </div>
                </div>
                <div className="gpc__order-detail-row">
                  <div className="gpc__order-detail-col">
                    {unfulfilled.map((item) => (
                      <ProductLine
                        {...item}
                        key={item.id}
                        currencyCode={order.currencyCode}
                      />
                    ))}
                  </div>
                </div>
              </InvertBox>
            ) : null}

            {fulfillments.map((fulfillment) => (
              <InvertBox key={fulfillment?.id}>
                {fulfillment.displayStatus ? (
                  <>
                    <div className="gpc__order-detail-row--fulfillment">
                      <div className="gpc__order-detail-col">
                        <FulfillmentStatus
                          status={fulfillment.displayStatus}
                          count={sumLineItems(fulfillment.lineItems)}
                        />
                      </div>
                      <div className="gpc__order-detail-col">
                        {fulfillment.name && <span>{fulfillment.name}</span>}
                      </div>
                    </div>
                    <div>
                      {fulfillment.trackingInfo?.map((info) => (
                        <TrackingStatus
                          key={info.number}
                          trackingInfo={info}
                          createdDate={fulfillment.createdAt}
                        />
                      ))}
                    </div>
                  </>
                ) : null}
                <div className="gpc__order-detail-row">
                  <div className="gpc__order-detail-col">
                    {fulfillment.lineItems.length > 1 ? (
                      <span>{lineItemsHeading(fulfillment.lineItems)}</span>
                    ) : null}
                    {(fulfillment.lineItems ?? []).map((item) => (
                      <ProductLine
                        {...item}
                        key={item.id}
                        currencyCode={order.currencyCode}
                      />
                    ))}
                  </div>
                </div>
              </InvertBox>
            ))}
          </>
        }
      </Box>
    </div>
  );
};

export default OrderDetails;
